/**
 * service-mail transaction-summary client. Mirrors:
 *   apps/service-mail/src/modules/transaction-summary/transaction-summary.controller.ts
 *
 * Endpoints (under `/v1/mail-items/summary`):
 *   GET /daily?operatorId=&date=YYYY-MM-DD
 *   GET /range?operatorId=&from=&to=
 */
import { env } from '../env';

import { request } from './client';

const baseUrl = (): string => env.serviceMailBaseUrl;

export interface DailySummaryResponse {
  readonly operatorId: number;
  readonly date: string;
  readonly registered: number;
  readonly delivered: number;
  readonly inTransit: number;
  readonly returned: number;
  readonly damaged: number;
  readonly lost: number;
  readonly revenueMinor: number;
}

export async function getDailySummary(
  operatorId: number,
  date: string,
): Promise<DailySummaryResponse> {
  return request<DailySummaryResponse>(baseUrl(), '/v1/mail-items/summary/daily', {
    method: 'GET',
    query: { operatorId, date },
  });
}

export async function getRangeSummary(
  operatorId: number,
  from: string,
  to: string,
): Promise<DailySummaryResponse> {
  return request<DailySummaryResponse>(baseUrl(), '/v1/mail-items/summary/range', {
    method: 'GET',
    query: { operatorId, from, to },
  });
}
